import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const CatalogImageBulkUpload = () => {
  return (
    <MicroFrontEnd
      name="CatalogImageBulkUpload"
      src={apiConfig.microFrontEnds.CatalogImageBulkUpload}
    />
  )
}

export default CatalogImageBulkUpload
